import styled, { css } from 'styled-components';

import type { ThemeColorType } from 'src/styles/theme';

const LegendTitleCSS = css`
  font-size: ${props => props.theme.fontSizes.displayXL} !important;
  font-family: ${props => props.theme.fonts.circular} !important;
  font-weight: ${props => props.theme.fontWeights.bold} !important;
  letter-spacing: ${props => props.theme.letterSpacings.normal} !important;
  line-height: ${props => props.theme.lineHeights.displayXL} !important;
  padding: ${props => props.theme.space.s3} 0 !important;
`;

export const MainTitle = styled.h1`
  ${LegendTitleCSS}
`;

export const LegendTitle = styled.legend`
  ${LegendTitleCSS}
`;

export const FieldSet = styled.fieldset`
  border: 0;
`;

export const ColorSpan = styled.span<{ color: ThemeColorType }>`
  color: ${props => props.theme.colors[props.color]};
`;
